import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = ["for", "innerHTML"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["data-target"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "o-form__instruction"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("div", {
    "data-component-name": _ctx.$options.name
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'o-label_w_tooltip': $props.field.inputTooltip && $props.field.inputTooltip.trim() != '' })
    }, [
      _createElementVNode("label", {
        class: "o-label",
        for: 'input-'+$props.field.id,
        innerHTML: ($props.field.inputRequired === true) ? $props.field.inputLabel + ' *' : $props.field.inputLabel 
      }, null, 8 /* PROPS */, _hoisted_2),
      ($props.field.inputTooltip && $props.field.inputTooltip.trim() != '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            id: 'tooltip-' + $props.field.id,
            class: _normalizeClass(["o-form__tooltip__container", {'is-active': $data.tooltipActive}])
          }, [
            _createElementVNode("span", {
              class: "o-form__tooltip__wrap",
              onClick: _cache[0] || (_cache[0] = $event => ($data.tooltipActive = !$data.tooltipActive))
            }, [
              _createElementVNode("span", {
                class: "o-form__tooltip",
                "data-module": "Tooltip",
                "data-target": '#tooltip-' + $props.field.id,
                "data-mid": "m9"
              }, [
                _createVNode(_component_svgIco, {
                  icon: "more-info",
                  class: "o-o-ico"
                })
              ], 8 /* PROPS */, _hoisted_4)
            ]),
            _createElementVNode("span", {
              class: "o-form__tooltip__content",
              innerHTML: $props.field.inputTooltip,
              "data-lenis-prevent": ""
            }, null, 8 /* PROPS */, _hoisted_5)
          ], 10 /* CLASS, PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($props.field.inputInstructions && $props.field.inputInstructions.trim() != '')
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
          _createElementVNode("small", {
            innerHTML: $props.field.inputInstructions
          }, null, 8 /* PROPS */, _hoisted_7)
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}